// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2964e3cf] .el-dialog__header{background-color:#d7d7d7}[data-v-2964e3cf] .el-checkbox{margin-top:10px;margin-left:20px}.choose_class[data-v-2964e3cf]{line-height:36px;font-size:40px;font-weight:700;color:#d7d7d7;text-align:center;cursor:pointer}", ""]);
// Exports
module.exports = exports;
